export default {
  lockEditAllMessage: 'Disable other functions in edit mode',
}
